import React, { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/components/_loading-screen.scss';

interface LoadingScreenProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  fullScreen = false 
}) => {
  const { isDarkMode } = useTheme();
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        switch(prev) {
          case '': return '.';
          case '.': return '..';
          case '..': return '...';
          default: return '';
        }
      });
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`loading-screen ${fullScreen ? 'loading-screen--fullscreen' : ''} ${isDarkMode ? 'loading-screen--dark' : ''}`}>
      <div className="loading-screen__container">
        <div className={`loading-screen__spinner loading-screen__spinner--${size}`}></div>
        <p className="loading-screen__message">
          <span className="loading-screen__text">{message}</span>
          <span className="loading-screen__dots">{dots}</span>
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;

